import {Component, Input, OnInit} from '@angular/core';
import {BaseLicensingInfoComponent} from '../base-licensing-info/base-licensing-info.component';
import {LicensingTierTemplate} from '../../interface/licensingTier.interface';
import {LicenseState} from '../../../../services/licensing.interfaces';
import {MatDialogRef} from '@angular/material/dialog';
import {LicensingRenewalDialogComponent} from '../../licensing-renewal-dialog.component';
import {DatePipe} from '@angular/common';
import {AppUser, AuthService} from '../../../../../../core/modules/auth/services/auth.service';
import {LocalStorageService} from '../../../../../../core/localStorage/local-storage.service';
import {CustomerService} from '../../../../../../core/modules/auth/services/customer.service';


@Component({
  selector: 'app-unlicensed-licensing-info',
  templateUrl: './unlicensed-licensing-info.component.html',
  styleUrls: ['../../licensing-renewal-dialog.component.scss']
})
export class UnlicensedLicensingInfoComponent extends BaseLicensingInfoComponent implements OnInit, LicensingTierTemplate {

  @Input() data: {
    licenseState: LicenseState;
    activeUser: AppUser;
    dialogRef: MatDialogRef<LicensingRenewalDialogComponent>;
  };

  constructor( public datePipe: DatePipe,
               public localStorageService: LocalStorageService,
               public authService: AuthService,
               public customerService: CustomerService) {
    super(datePipe, localStorageService, authService, customerService);
  }

  ngOnInit(): void {
    this.sourceData = this.data;
    super.ngOnInit();
    this.buildTemplateData(this.sourceData.licenseState);
  }

  buildTemplateData(licenseState: LicenseState): void {
    this.templateData = {
      domain: licenseState.license.domain,
      plan: 'Unlicensed',
      expiryMessage: `Whoops! It looks like ${licenseState.license.domain} does not have a license for Little SIS for Classroom`,

    };
  }

}
